import { Box, Button, MenuItem, TextField } from "@mui/material";
import { getCredentialsBadge } from "components/shared/Tables/helper";
import tables from "components/shared/Tables/table.module.scss";
import CryptoJS from "crypto-js";

export const NavItems = [
  { label: "Network Key Features Monitoring" },
  // { label: "Network Streamlined Monitoring" },
  // { label: "Network Customizable Analysis" },
];

export const CONNECTED_CHILD_ICON = `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="17.9361" cy="17.5201" r="16.0397" fill="white" stroke="#00A307" stroke-width="2"/>
  <path d="M20.1727 16.5059H16.1354C15.7485 16.5059 15.4334 16.8225 15.4334 17.2079V24.2388C15.4334 24.6257 15.7501 24.9408 16.1354 24.9408H20.1727C20.5596 24.9408 20.8747 24.6241 20.8747 24.2388V17.2079C20.8747 16.821 20.5596 16.5059 20.1727 16.5059ZM18.1541 20.0252C17.4926 20.0252 16.9575 19.4902 16.9575 18.8287C16.9575 18.1673 17.4942 17.6322 18.1541 17.6322C18.8139 17.6322 19.3506 18.1688 19.3506 18.8287C19.3506 19.4886 18.8155 20.0252 18.1541 20.0252Z" fill="#00A307"/>
  <path d="M20.1751 16.3496C19.8896 16.3496 19.6041 16.3496 19.3187 16.3496C18.7446 16.3496 18.1689 16.3496 17.5949 16.3496C17.1534 16.3496 16.7103 16.3496 16.2689 16.3496C16.1004 16.3496 15.9397 16.3574 15.7821 16.4292C15.4732 16.568 15.2814 16.8832 15.2798 17.2186C15.2782 17.4416 15.2798 17.6647 15.2798 17.8878C15.2798 18.362 15.2798 18.8378 15.2798 19.3121C15.2798 19.9002 15.2798 20.4868 15.2798 21.0749C15.2798 21.6381 15.2798 22.1997 15.2798 22.7628C15.2798 23.1559 15.2798 23.5475 15.2798 23.9406C15.2798 24.0295 15.2798 24.12 15.2798 24.209C15.2798 24.457 15.3672 24.6988 15.5544 24.8688C15.7384 25.0373 15.9631 25.0997 16.2065 25.0997C16.3578 25.0997 16.5075 25.0997 16.6589 25.0997C17.2017 25.0997 17.7462 25.0997 18.2891 25.0997C18.8023 25.0997 19.3171 25.0997 19.8303 25.0997C19.9411 25.0997 20.0519 25.0997 20.1626 25.0997C20.5246 25.0982 20.8459 24.8798 20.9785 24.5412C21.0643 24.3197 21.0331 24.0436 21.0331 23.8111C21.0331 23.3837 21.0331 22.9578 21.0331 22.5304C21.0331 21.9579 21.0331 21.3838 21.0331 20.8113C21.0331 20.2294 21.0331 19.6475 21.0331 19.0656C21.0331 18.6194 21.0331 18.1748 21.0331 17.7287C21.0331 17.5368 21.0472 17.3387 21.03 17.1452C20.991 16.6975 20.6213 16.3559 20.1751 16.3496C19.9739 16.3465 19.9739 16.6585 20.1751 16.6616C20.4778 16.6663 20.718 16.9097 20.7211 17.2123C20.7211 17.2747 20.7211 17.3371 20.7211 17.398C20.7211 17.7412 20.7211 18.0844 20.7211 18.4291C20.7211 18.9595 20.7211 19.4899 20.7211 20.0188C20.7211 20.5991 20.7211 21.1794 20.7211 21.7613C20.7211 22.2652 20.7211 22.7706 20.7211 23.2745C20.7211 23.5662 20.7211 23.8595 20.7211 24.1512C20.7211 24.2526 20.7211 24.3494 20.6806 24.4461C20.5885 24.6707 20.3701 24.7846 20.1377 24.7846C19.7757 24.7846 19.4154 24.7846 19.0535 24.7846C18.4809 24.7846 17.9084 24.7846 17.3375 24.7846C16.9568 24.7846 16.5762 24.7846 16.1955 24.7846C15.9974 24.7846 15.8118 24.7238 15.6916 24.5537C15.6105 24.4367 15.5918 24.3088 15.5918 24.1715C15.5918 23.8923 15.5918 23.613 15.5918 23.3353C15.5918 22.8377 15.5918 22.3401 15.5918 21.844C15.5918 21.2637 15.5918 20.6833 15.5918 20.1046C15.5918 19.5695 15.5918 19.0328 15.5918 18.4978C15.5918 18.1421 15.5918 17.7864 15.5918 17.4307C15.5918 17.3605 15.5918 17.2903 15.5918 17.2186C15.5934 16.9502 15.7774 16.724 16.0411 16.671C16.1316 16.6523 16.2361 16.6632 16.3281 16.6632C16.5169 16.6632 16.7041 16.6632 16.8929 16.6632C17.4513 16.6632 18.0098 16.6632 18.5667 16.6632C19.0301 16.6632 19.4934 16.6632 19.9567 16.6632C20.03 16.6632 20.1033 16.6632 20.1767 16.6632C20.3764 16.6616 20.3764 16.3496 20.1751 16.3496Z" fill="#00A307"/>
  <path d="M18.161 19.8691C17.7351 19.866 17.3326 19.6008 17.186 19.1952C17.0331 18.7756 17.1595 18.3107 17.5011 18.0237C17.8334 17.7444 18.3264 17.7148 18.6961 17.9347C19.0643 18.1547 19.2702 18.5993 19.1859 19.0236C19.0861 19.5103 18.6587 19.8645 18.161 19.8691C17.9598 19.8707 17.9598 20.1827 18.161 20.1811C18.7304 20.1765 19.2359 19.8192 19.434 19.2873C19.6274 18.7647 19.4589 18.1407 19.0268 17.7897C18.5853 17.4293 17.952 17.3716 17.4606 17.6711C16.9723 17.9691 16.7258 18.5478 16.8366 19.1063C16.9614 19.7303 17.5323 20.1765 18.161 20.1811C18.3623 20.1827 18.3623 19.8707 18.161 19.8691Z" fill="#00A307"/>
  <path d="M15.9025 14.7545C15.9883 14.6687 16.0788 14.586 16.1739 14.5096C16.1973 14.4909 16.2207 14.4706 16.2441 14.4534C16.2238 14.469 16.2051 14.4846 16.1848 14.4987C16.1973 14.4893 16.2082 14.4799 16.2207 14.4721C16.2691 14.4363 16.3174 14.4019 16.3674 14.3692C16.5561 14.2428 16.7574 14.1352 16.968 14.0463C16.9305 14.0619 16.8931 14.0775 16.8557 14.0931C17.1552 13.9683 17.4687 13.8825 17.7901 13.8388C17.748 13.845 17.7074 13.8497 17.6653 13.8559C17.9851 13.8138 18.308 13.8138 18.6278 13.8559C18.5857 13.8497 18.5451 13.845 18.503 13.8388C18.8244 13.8825 19.1379 13.9667 19.4375 14.0931C19.4 14.0775 19.3626 14.0619 19.3251 14.0463C19.5342 14.1352 19.7354 14.2428 19.9257 14.3692C19.9757 14.4019 20.024 14.4363 20.0724 14.4721C20.0989 14.4909 20.166 14.5486 20.049 14.4534C20.0724 14.4721 20.0958 14.4909 20.1192 14.5096C20.2143 14.5876 20.3033 14.6687 20.3906 14.7545C20.5638 14.9277 20.8805 14.9417 21.0521 14.7545C21.2237 14.5689 21.2377 14.2771 21.0521 14.0931C20.4655 13.5096 19.6964 13.0947 18.8774 12.9574C18.0257 12.8139 17.177 12.9246 16.3923 13.2834C15.9633 13.48 15.5718 13.7623 15.2379 14.0946C15.0648 14.2678 15.0523 14.586 15.2379 14.7561C15.4282 14.9261 15.7168 14.9386 15.9025 14.7545Z" fill="#00A307"/>
  <path d="M13.0998 13.2239C13.2386 13.0866 13.3806 12.954 13.5288 12.8261C13.6005 12.7653 13.6738 12.7044 13.7472 12.6451C13.7643 12.6311 13.783 12.6171 13.8002 12.603C13.861 12.5547 13.7144 12.6685 13.7768 12.6217C13.8158 12.5921 13.8548 12.5625 13.8938 12.5344C14.1949 12.3129 14.5131 12.1147 14.8438 11.94C15.031 11.8417 15.2229 11.7513 15.4179 11.6686C15.3805 11.6842 15.343 11.6998 15.3056 11.7154C15.9296 11.4517 16.5879 11.2723 17.2587 11.1818C17.2166 11.1881 17.1761 11.1928 17.1339 11.199C17.8079 11.1101 18.4927 11.1101 19.1666 11.199C19.1245 11.1928 19.0839 11.1881 19.0418 11.1818C19.7142 11.2723 20.3709 11.4517 20.9949 11.7154C20.9575 11.6998 20.9201 11.6842 20.8826 11.6686C21.2227 11.8137 21.5534 11.9821 21.8686 12.174C22.0308 12.2723 22.1884 12.3768 22.3428 12.4876C22.3787 12.5141 22.4161 12.5406 22.452 12.5671C22.4707 12.5812 22.4879 12.5937 22.5066 12.6077C22.516 12.6139 22.5238 12.6217 22.5331 12.628C22.5784 12.6623 22.4473 12.5609 22.4926 12.5968C22.5659 12.6561 22.6408 12.7138 22.7125 12.7746C22.8826 12.9166 23.0448 13.0679 23.2024 13.2239C23.3755 13.3971 23.6938 13.4111 23.8638 13.2239C24.0354 13.0367 24.0494 12.7465 23.8638 12.5625C23.2726 11.9728 22.5877 11.4673 21.842 11.0867C21.1197 10.7185 20.3444 10.4533 19.5457 10.3192C18.7501 10.185 17.9436 10.1569 17.1449 10.263C16.3024 10.3738 15.4975 10.6031 14.7237 10.9588C13.9687 11.3066 13.2714 11.784 12.6598 12.3472C12.5834 12.4174 12.5085 12.4891 12.4352 12.5625C12.262 12.7356 12.2495 13.0539 12.4352 13.2239C12.624 13.3971 12.9141 13.4095 13.0998 13.2239Z" fill="#00A307"/>
  </svg>
  `;
export const DISCONNECTED_CHILD_ICON = `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="17.9635" cy="17.0397" r="16.0397" fill="white" stroke="#FF0000" stroke-width="2"/>
  <path d="M20.001 15.9053H15.9637C15.5768 15.9053 15.2617 16.222 15.2617 16.6073V23.6382C15.2617 24.0251 15.5784 24.3402 15.9637 24.3402H20.001C20.3879 24.3402 20.703 24.0236 20.703 23.6382V16.6073C20.703 16.2204 20.3879 15.9053 20.001 15.9053ZM17.9824 19.4247C17.3209 19.4247 16.7858 18.8896 16.7858 18.2281C16.7858 17.5667 17.3225 17.0316 17.9824 17.0316C18.6423 17.0316 19.1789 17.5682 19.1789 18.2281C19.1789 18.888 18.6438 19.4247 17.9824 19.4247Z" fill="#FF0000"/>
  <path d="M20.0015 15.749C19.716 15.749 19.4305 15.749 19.145 15.749C18.5709 15.749 17.9953 15.749 17.4212 15.749C16.9797 15.749 16.5367 15.749 16.0952 15.749C15.9267 15.749 15.766 15.7568 15.6085 15.8286C15.2996 15.9674 15.1077 16.2826 15.1062 16.618C15.1046 16.8411 15.1062 17.0641 15.1062 17.2872C15.1062 17.7615 15.1062 18.2373 15.1062 18.7115C15.1062 19.2996 15.1062 19.8862 15.1062 20.4743C15.1062 21.0375 15.1062 21.5991 15.1062 22.1622C15.1062 22.5554 15.1062 22.9469 15.1062 23.34C15.1062 23.429 15.1062 23.5194 15.1062 23.6084C15.1062 23.8564 15.1935 24.0982 15.3807 24.2682C15.5648 24.4367 15.7894 24.4991 16.0328 24.4991C16.1841 24.4991 16.3339 24.4991 16.4852 24.4991C17.0281 24.4991 17.5725 24.4991 18.1154 24.4991C18.6287 24.4991 19.1435 24.4991 19.6567 24.4991C19.7675 24.4991 19.8782 24.4991 19.989 24.4991C20.3509 24.4976 20.6723 24.2792 20.8049 23.9406C20.8907 23.7191 20.8595 23.443 20.8595 23.2106C20.8595 22.7831 20.8595 22.3572 20.8595 21.9298C20.8595 21.3573 20.8595 20.7832 20.8595 20.2107C20.8595 19.6288 20.8595 19.0469 20.8595 18.465C20.8595 18.0189 20.8595 17.5743 20.8595 17.1281C20.8595 16.9362 20.8735 16.7381 20.8563 16.5447C20.8173 16.0969 20.4476 15.7553 20.0015 15.749C19.8002 15.7459 19.8002 16.0579 20.0015 16.061C20.3041 16.0657 20.5443 16.3091 20.5475 16.6117C20.5475 16.6741 20.5475 16.7365 20.5475 16.7974C20.5475 17.1406 20.5475 17.4838 20.5475 17.8285C20.5475 18.3589 20.5475 18.8893 20.5475 19.4182C20.5475 19.9985 20.5475 20.5788 20.5475 21.1607C20.5475 21.6646 20.5475 22.17 20.5475 22.6739C20.5475 22.9656 20.5475 23.2589 20.5475 23.5506C20.5475 23.652 20.5475 23.7488 20.5069 23.8455C20.4149 24.0701 20.1965 24.184 19.964 24.184C19.6021 24.184 19.2417 24.184 18.8798 24.184C18.3073 24.184 17.7348 24.184 17.1638 24.184C16.7832 24.184 16.4025 24.184 16.0219 24.184C15.8238 24.184 15.6381 24.1232 15.518 23.9531C15.4369 23.8361 15.4182 23.7082 15.4182 23.5709C15.4182 23.2917 15.4182 23.0124 15.4182 22.7348C15.4182 22.2371 15.4182 21.7395 15.4182 21.2434C15.4182 20.6631 15.4182 20.0827 15.4182 19.504C15.4182 18.9689 15.4182 18.4323 15.4182 17.8972C15.4182 17.5415 15.4182 17.1858 15.4182 16.8301C15.4182 16.7599 15.4182 16.6897 15.4182 16.618C15.4197 16.3496 15.6038 16.1234 15.8674 16.0704C15.9579 16.0517 16.0624 16.0626 16.1545 16.0626C16.3432 16.0626 16.5304 16.0626 16.7192 16.0626C17.2777 16.0626 17.8362 16.0626 18.3931 16.0626C18.8564 16.0626 19.3197 16.0626 19.7831 16.0626C19.8564 16.0626 19.9297 16.0626 20.003 16.0626C20.2027 16.061 20.2027 15.749 20.0015 15.749Z" fill="#FF0000"/>
  <path d="M17.9874 19.2686C17.5615 19.2654 17.159 19.0002 17.0124 18.5946C16.8595 18.175 16.9858 17.7101 17.3275 17.4231C17.6598 17.1438 18.1527 17.1142 18.5224 17.3341C18.8906 17.5541 19.0965 17.9987 19.0123 18.423C18.9125 18.9098 18.485 19.2639 17.9874 19.2686C17.7861 19.2701 17.7861 19.5821 17.9874 19.5806C18.5568 19.5759 19.0622 19.2186 19.2603 18.6867C19.4538 18.1641 19.2853 17.5401 18.8532 17.1891C18.4117 16.8287 17.7783 16.771 17.2869 17.0705C16.7986 17.3685 16.5522 17.9472 16.6629 18.5057C16.7877 19.1297 17.3587 19.5759 17.9874 19.5806C18.1886 19.5821 18.1886 19.2701 17.9874 19.2686Z" fill="#FF0000"/>
  <path d="M15.7347 14.1529C15.8205 14.0671 15.911 13.9845 16.0061 13.908C16.0295 13.8893 16.0529 13.869 16.0763 13.8519C16.0561 13.8675 16.0373 13.8831 16.0171 13.8971C16.0295 13.8877 16.0405 13.8784 16.0529 13.8706C16.1013 13.8347 16.1497 13.8004 16.1996 13.7676C16.3883 13.6413 16.5896 13.5336 16.8002 13.4447C16.7627 13.4603 16.7253 13.4759 16.6879 13.4915C16.9874 13.3667 17.3009 13.2809 17.6223 13.2372C17.5802 13.2435 17.5396 13.2481 17.4975 13.2544C17.8173 13.2123 18.1402 13.2123 18.46 13.2544C18.4179 13.2481 18.3774 13.2435 18.3352 13.2372C18.6566 13.2809 18.9702 13.3651 19.2697 13.4915C19.2322 13.4759 19.1948 13.4603 19.1574 13.4447C19.3664 13.5336 19.5676 13.6413 19.758 13.7676C19.8079 13.8004 19.8562 13.8347 19.9046 13.8706C19.9311 13.8893 19.9982 13.947 19.8812 13.8519C19.9046 13.8706 19.928 13.8893 19.9514 13.908C20.0466 13.986 20.1355 14.0671 20.2228 14.1529C20.396 14.3261 20.7127 14.3401 20.8843 14.1529C21.0559 13.9673 21.0699 13.6756 20.8843 13.4915C20.2977 12.9081 19.5286 12.4931 18.7096 12.3558C17.8579 12.2123 17.0092 12.3231 16.2245 12.6819C15.7955 12.8784 15.404 13.1608 15.0701 13.4931C14.897 13.6662 14.8845 13.9845 15.0701 14.1545C15.2605 14.3245 15.5491 14.337 15.7347 14.1529Z" fill="#FF0000"/>
  <path d="M12.932 12.6223C13.0708 12.4851 13.2128 12.3525 13.361 12.2245C13.4327 12.1637 13.506 12.1029 13.5794 12.0436C13.5965 12.0295 13.6153 12.0155 13.6324 12.0015C13.6933 11.9531 13.5466 12.067 13.609 12.0202C13.648 11.9905 13.687 11.9609 13.726 11.9328C14.0271 11.7113 14.3453 11.5132 14.6761 11.3384C14.8633 11.2402 15.0551 11.1497 15.2501 11.067C15.2127 11.0826 15.1753 11.0982 15.1378 11.1138C15.7618 10.8502 16.4201 10.6708 17.0909 10.5803C17.0488 10.5865 17.0083 10.5912 16.9661 10.5974C17.6401 10.5085 18.3249 10.5085 18.9988 10.5974C18.9567 10.5912 18.9162 10.5865 18.874 10.5803C19.5464 10.6708 20.2032 10.8502 20.8272 11.1138C20.7897 11.0982 20.7523 11.0826 20.7148 11.067C21.0549 11.2121 21.3856 11.3806 21.7008 11.5724C21.863 11.6707 22.0206 11.7753 22.175 11.886C22.2109 11.9125 22.2483 11.9391 22.2842 11.9656C22.3029 11.9796 22.3201 11.9921 22.3388 12.0061C22.3482 12.0124 22.356 12.0202 22.3653 12.0264C22.4106 12.0607 22.2795 11.9593 22.3248 11.9952C22.3981 12.0545 22.473 12.1122 22.5447 12.1731C22.7148 12.315 22.877 12.4663 23.0346 12.6223C23.2077 12.7955 23.526 12.8095 23.696 12.6223C23.8676 12.4351 23.8817 12.145 23.696 11.9609C23.1048 11.3712 22.4199 10.8658 21.6742 10.4851C20.952 10.117 20.1766 9.85176 19.3779 9.7176C18.5823 9.58344 17.7758 9.55536 16.9771 9.66144C16.1347 9.7722 15.3297 10.0015 14.5559 10.3572C13.8009 10.7051 13.1036 11.1824 12.492 11.7456C12.4156 11.8158 12.3407 11.8876 12.2674 11.9609C12.0942 12.1341 12.0818 12.4523 12.2674 12.6223C12.4562 12.7955 12.7463 12.808 12.932 12.6223Z" fill="#FF0000"/>
  </svg>
  `;

export const CONNECTED_PARENT_ICON = `<svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="17" cy="17.3047" r="16" fill="white" stroke="#00A307" stroke-width="2"/>
<path d="M24.575 22.4922H18.1347C18.115 23.0726 17.7439 23.4297 17.265 23.4297H15.65C15.1535 23.4297 14.7729 22.9179 14.7795 22.4922H8.425C8.19125 22.4922 8 22.7031 8 22.9609V23.4297C8 24.4609 8.765 25.3047 9.7 25.3047H23.3C24.235 25.3047 25 24.4609 25 23.4297V22.9609C25 22.7031 24.8088 22.4922 24.575 22.4922ZM23.3 11.7109C23.3 10.9375 22.7263 10.3047 22.025 10.3047H10.975C10.2738 10.3047 9.7 10.9375 9.7 11.7109V21.5547H23.3V11.7109ZM21.6 19.6797H11.4V12.1797H21.6V19.6797Z" fill="#00A307"/>
</svg>
`;

export const DISCONNECTED_PARENT_ICON = `<svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="17" cy="17.3047" r="16" fill="white" stroke="#FF0000" stroke-width="2"/>
<path d="M24.575 22.4922H18.1347C18.115 23.0726 17.7439 23.4297 17.265 23.4297H15.65C15.1535 23.4297 14.7729 22.9179 14.7795 22.4922H8.425C8.19125 22.4922 8 22.7031 8 22.9609V23.4297C8 24.4609 8.765 25.3047 9.7 25.3047H23.3C24.235 25.3047 25 24.4609 25 23.4297V22.9609C25 22.7031 24.8088 22.4922 24.575 22.4922ZM23.3 11.7109C23.3 10.9375 22.7263 10.3047 22.025 10.3047H10.975C10.2738 10.3047 9.7 10.9375 9.7 11.7109V21.5547H23.3V11.7109ZM21.6 19.6797H11.4V12.1797H21.6V19.6797Z" fill="#FF0000"/>
</svg>
`;

export const getNetworkCols = (handleChange, validationErrors, canEdit, handleIpChange) => [
  {
    field: "systemDetails",
    headerName: "IP Address",
    flex: 1,
    renderCell: (params) => (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        style={{ height: '100%' }}
      >
        <TextField
          placeholder="Enter IP Address"
          value={params?.row?.ip || ''}
          onChange={(e) => handleIpChange && handleIpChange(params.row.id, e.target.value)}
          fullWidth
          autoComplete='off'
          style={{ margin: '5px 0', height: '30px' }}
          InputProps={{
            style: { height: '30px' }
          }}
          disabled={canEdit ? !canEdit(params.row) : params?.row?.credentials?.isVerified}
        />
      </Box>
    )
  },
  {
    field: "size",
    headerName: "Status",
    flex: 1,
    renderCell: (params) => getCredentialsBadge(params?.row?.credentials?.isVerified)
  },
  {
    field: "username",
    headerName: "Username",
    flex: 1,
    renderCell: (params) => (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        style={{ height: '100%' }}
      >
        <TextField
          placeholder="Enter Username"
          value={params?.row?.credentials?.username}
          onChange={(e) => handleChange(params.row.id, 'username', e.target.value)}
          fullWidth
          autoComplete='off'
          style={{ margin: '5px 0', height: '30px' }}
          disabled={canEdit ? !canEdit(params.row) : params?.row?.credentials?.isVerified}
          InputProps={{
            style: { height: '30px' },
            error: validationErrors[params.row.id]?.username
          }}
        />
      </Box>
    ),
  },
  {
    field: "password",
    headerName: "Password",
    flex: 1,
    renderCell: (params) => (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        style={{ height: '100%' }}
      >
        <TextField
          placeholder="Enter Password"
          type="password"
          value={params.row.credentials.password}
          onChange={(e) => handleChange(params.row.id, 'password', e.target.value)}
          fullWidth
          disabled={canEdit ? !canEdit(params.row) : params?.row?.credentials?.isVerified}
          autoComplete='off'
          style={{ margin: '5px 0', height: '30px' }}
          InputProps={{
            style: { height: '30px' },
            error: validationErrors[params.row.id]?.password
          }}
        />
      </Box>
    ),
  },
  {
    field: "deviceType",
    headerName: "Device Type",
    flex: 1,
    renderCell: (params) => (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        style={{ height: '100%' }}
      >
        <TextField
          select
          placeholder="Select Device Type"
          value={params.row.credentials.deviceType}
          onChange={(e) => handleChange(params.row.id, 'deviceType', e.target.value)}
          fullWidth
          disabled={canEdit ? !canEdit(params.row) : params?.row?.credentials?.isVerified}
          style={{ margin: '5px 0', height: '30px' }}
          InputProps={{
            style: { height: '30px' },
            error: validationErrors[params.row.id]?.deviceType
          }}
        >
          <MenuItem value={"router"}>Router</MenuItem>
          <MenuItem value={"switch"}>Switch</MenuItem>
          <MenuItem value={"firewall"}>Firewall</MenuItem>
          <MenuItem value={"accessPoint"}>Access Point</MenuItem>
          <MenuItem value={"server"}>Server</MenuItem>
          <MenuItem value={"modem"}>Modem</MenuItem>
          <MenuItem value={"pc"}>PC</MenuItem>
        </TextField>
      </Box>
    ),
  },
];

export const STREMLINED_NWTWORK_COLUMNS = [
  {
    field: "name",
    headerName: "Name",
    minWidth: 100,
    flex: 1,
  },
  {
    field: "interface",
    headerName: "Interface",
    minWidth: 150,
    flex: 1,
  },
  {
    field: "recentErrors",
    headerName: "Recent Errors",
    minWidth: 150,
    flex: 1,
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 100,
    flex: 1,
    renderCell: (params) => (
      <Button
        variant="contained"
        size="small"
        style={{
          backgroundColor: params.row.status === "Warning" ? "orange" : "green",
          color: "white",
          borderRadius: "25px",
          marginLeft: "-25px",
        }}
      >
        {params.row.status}
      </Button>
    ),
  },
  {
    field: "lastActive",
    headerName: "Last Active",
    minWidth: 150,
    flex: 1,
  },
  {
    field: "actions",
    headerName: "Actions",
    minWidth: 150,
    flex: 1,
    renderCell: (params) => (
      <Button
        variant="contained"
        size="small"
        color="primary"
        className={tables.actionBtn}
      >
        {params.row.actions}
      </Button>
    ),
  },
];

export const CUSTOMIZEABLE_NETWORK_COLUMNS = [
  {
    field: "name",
    headerName: "Network Name",
    minWidth: 100,
    flex: 1,
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 100,
    flex: 1,
    renderCell: (params) => (
      <Button
        variant="contained"
        size="small"
        style={{
          backgroundColor: params.row.status === "Warning" ? "orange" : "green",
          color: "white",
          borderRadius: "25px",
          marginLeft: "-25px",
        }}
      >
        {params.row.status}
      </Button>
    ),
  },
  {
    field: "lastActive",
    headerName: "Last Active",
    minWidth: 150,
    flex: 1,
  },
];

export const RAM_CPU_CHART_OPTION = {
  series: [
    {
      name: "RAM",
      data: [80, 90, 70, 60, 50, 10],
    },
    {
      name: "CPU",
      data: [20, 60, 80, 50, 20, 70],
    },
    {
      name: "Disk",
      data: [60, 20, 40, 30, 90, 100],
    },
  ],
  chart: {
    type: "bar",
    height: 200,
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  colors: ["#0C5E9B", "#FEB72F", "#D0D3D5"],
  plotOptions: {
    bar: {
      borderRadius: 5,
      borderRadiusApplication: "around",
      borderRadiusWhenStacked: "all",
      columnWidth: "10px",
    },
  },
  grid: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: ["0", "1", "2", "3", "4", "5"],
    axisBorder: {
      show: true,
      color: "#000",
      height: 1,
      offsetX: 0,
      offsetY: 1,
    },
    axisTicks: {
      show: true,
      borderType: "solid",
      color: "#000",
      width: 6,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
      color: "#000",
      offsetX: -1,
    },
    axisTicks: {
      show: true,
      borderType: "solid",
      color: "#000",
      width: 6,
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
};

export const CONNECTION_CHART_OPTION = {
  series: [
    {
      name: "In Use",
      data: [800, 700, 650, 300, 400, 500, 750, 800],
    },
  ],
  chart: {
    type: "bar",
    height: 200,
    toolbar: {
      show: false,
    },
  },
  colors: ["#0C5E9B"],
  plotOptions: {
    bar: {
      borderRadius: 5,
      columnWidth: "10px",
    },
  },
  grid: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: ["0", "1", "2", "3", "4", "5", "6", "7"],
    axisBorder: {
      show: true,
      color: "#000",
      height: 1,
      offsetX: 0,
      offsetY: 1,
    },
    axisTicks: {
      show: true,
      borderType: "solid",
      color: "#000",
      width: 6,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
      color: "#000",
      offsetX: -1,
    },
    axisTicks: {
      show: true,
      borderType: "solid",
      color: "#000",
      width: 6,
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
};


export const validateCredentials = (credentials, setValidationErrors, validationErrors) => {
  let isValid = true;
  const newErrors = { ...validationErrors };

  for (const [ip, credential] of Object.entries(credentials)) {
    if (!credential.username) {
      newErrors[ip].username = true;
      isValid = false;
    } else {
      newErrors[ip].username = false;
    }

    if (!credential.password) {
      newErrors[ip].password = true;
      isValid = false;
    } else {
      newErrors[ip].password = false;
    }

    if (!credential.deviceType) {
      newErrors[ip].deviceType = true;
      isValid = false;
    } else {
      newErrors[ip].deviceType = false;
    }
  }

  setValidationErrors(newErrors);
  return isValid;
};


export const encryptUserData = (data) => {
  const encryptedData = {};

  Object.keys(data).forEach(key => {
    encryptedData[key] = {
      username: encryptMessage(data[key].username),
      password: encryptMessage(data[key].password),
      ...data?.[key]
    };
  });

  return encryptedData;
};

export const encryptMessage = (message) => {
  const encryptedMessage = CryptoJS.AES.encrypt(
    message,
    process.env.REACT_APP_EMAIL_SECRET
  ).toString();
  return encryptedMessage
}